export default "__VITE_ASSET___kQo9Su1__"